__turbopack_context__.v({
  "dropzoneHint": "es8FNG_dropzoneHint",
  "dropzoneIcon": "es8FNG_dropzoneIcon",
});
